var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PreviewRenderer"},[_c('vue-components-markdown',{attrs:{"content":_vm.content,"component-map":_vm.componentMap,"variables":_vm.variables,"no-component-wrapper":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }